import React, { useRef, useState, useEffect } from 'react'
import { Link, useHistory, useParams } from "react-router-dom"
import { fetch_institute_testSeries_section } from '../../../api/testSeries/testseries';
import Sections from './Sections';
// import DocxParser from './DocxParser';
import DragAndDrop from './DragAndDrop';
import { ImageToQuestionArray } from '../../../api/testSeries/ocr';

function TestSeries() {
    const history = useHistory();
    const sectionsRef = useRef();
    const [activeSection, setActiveSection] = useState()
    const [showSection, setShowSection] = useState(false)
    const { testSeriesId } = useParams()
    const fileChooserRef = useRef(null)
    const [file, setFile] = useState(null)
    const dragFileRef = useRef(null)
    const onFileChange = async (e) => {
        const file = e.target.files[0];
        dragFileRef.current.setFileFromParent(file)
        
    }

   
    return (
        // <DragAndDrop ref={dragFileRef} sectionsRef={sectionsRef} file={file}>
            <div>
                <div class="page-breadcrumb  d-md-flex align-items-center mb-3">
                    <div class="breadcrumb-title pr-3">Test Series</div>
                    <div class="pl-3">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb mb-0 p-0">
                                <li class="breadcrumb-item"><a href="javascript:;"><i class='bx bx-home-alt'></i></a>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div class="ml-auto">
                        <div class="btn-group">
                            <div>
                               
                                <button type="button" class="btn btn-success mr-3" data-toggle="modal" data-target="#addSectionModal" onClick={() => { fileChooserRef.current.click() }}>
                                    Import Bulk
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-success mr-3" data-toggle="modal" data-target="#addSectionModal" onClick={() => { sectionsRef.current.openAddSectionModal() }}>
                                    + Add Section
                                </button>
                            </div>
                            <button type="button" class="btn btn-dark" onClick={() => history.goBack()}>Go Back</button>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-start" style={{ marginBottom: 10, marginRight: 5, width: "100%" }}>
                    <Sections ref={sectionsRef} setActiveSection={setActiveSection} activeSection={activeSection} testSeriesId={testSeriesId} />
                </div>
                <input type="file" ref={fileChooserRef} onChange={onFileChange} style={{visibility:"hidden"}} />
            </div>
        // </DragAndDrop>
    )
}

export default TestSeries